import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useAuth } from '../../../context/AuthContext';
import Modal from 'react-modal';
import { config } from '../../../config';

function getOrderPeriodLabel(order) {
    return order?.orderPeriod?.periodLabel || '—';
}

function getOrderDistributionLabel(order) {
    return order?.orderPeriod?.distributionLabel || '—';
}

const Orders = () => {
    const { user, token } = useAuth();
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedOrder, setSelectedOrder] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);

    useEffect(() => {
        const fetchOrders = async () => {
            setLoading(true);
            try {
                const res = await axios.get(`${config.API_BASE}/api/orders?customerId=${user._id}`, {
                    headers: { Authorization: `Bearer ${token}` }
                });
                setOrders(res.data);
            } catch (err) {
                setOrders([]);
            }
            setLoading(false);
        };
        if (user && token) fetchOrders();
    }, [user, token]);

    const openModal = (order) => {
        setSelectedOrder(order);
        setModalOpen(true);
    };
    const closeModal = () => {
        setModalOpen(false);
        setSelectedOrder(null);
    };

    return (
        <div style={{padding: 24}}>
            <h2>My Orders</h2>
            {loading ? <div>Loading...</div> : orders.length === 0 ? <div>No orders found.</div> : (
                <>
                <table className="table table-bordered mt-3">
                    <thead>
                        <tr>
                            <th>Order ID</th>
                            <th>Customer Name</th>
                            <th>Order Date</th>
                            <th>Order Period</th>
                            <th>Order Total</th>
                            <th>Distribution Date</th>
                            <th>Payment Status</th>
                            <th>View</th>
                        </tr>
                    </thead>
                    <tbody>
                        {orders.map(order => {
                            return (
                                <tr key={order._id}>
                                    <td>{order.orderNumber || order._id}</td>
                                    <td>{user.firstname}, {user.lastname}</td>
                                    <td>{new Date(order.createdAt).toLocaleString()}</td>
                                    <td>{getOrderPeriodLabel(order)}</td>
                                    <td>${Number(order.total).toFixed(2)}</td>
                                    <td>{getOrderDistributionLabel(order)}</td>
                                    <td>{order.status}</td>
                                    <td>
                                        <a href="#" className="text-primary" onClick={e => { e.preventDefault(); openModal(order); }}>View</a>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
                <Modal
                    isOpen={modalOpen}
                    onRequestClose={closeModal}
                    contentLabel="Order Items"
                    ariaHideApp={false}
                    style={{ content: { maxWidth: 600, margin: 'auto' } }}
                >
                    <h3>Order Items</h3>
                    <button onClick={closeModal} style={{ float: 'right', marginTop: -40, fontSize: 24, background: 'none', border: 'none' }}>&times;</button>
                    {selectedOrder && selectedOrder.items && selectedOrder.items.length > 0 ? (
                        <table className="table table-bordered mt-3">
                            <thead>
                                <tr>
                                    <th>Item</th>
                                    <th>Farm Name</th>
                                    <th>Image</th>
                                    <th>Quantity</th>
                                    <th>Total Cost</th>
                                </tr>
                            </thead>
                            <tbody>
                                {selectedOrder.items.map((item, idx) => (
                                    <tr key={item.productId || item._id || item.id}>
                                        <td>{item.productId?.title || item.productId?.name || 'N/A'}</td>
                                        <td>{item.producerId?.farmName || item.producerId?.name || 'N/A'}</td>
                                        <td>
                                            {item.productId?.media && item.productId.media[0] ? (
                                                <img src={item.productId.media[0]} alt={item.productId?.title || item.productId?.name} style={{ width: 50, height: 50, objectFit: 'cover' }} />
                                            ) : 'No Image'}
                                        </td>
                                        <td>{item.quantity}</td>
                                        <td>${Number((item.price || 0) * (item.quantity || 1)).toFixed(2)}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    ) : <div>No items found for this order.</div>}
                </Modal>
                </>
            )}
        </div>
    );
};

export default Orders; 